import anime from 'animejs'

export const createLoadingAnimation = (cssSelector: string) => {
  return anime({
    targets: cssSelector,
    y1: ['50%', '0%', '50%'],
    y2: ['50%', '100%', '50%'],
    easing: 'easeInOutQuad',
    delay: anime.stagger(10, { start: 500 }),
    duration: 1000,
    loop: true
  })
}

const staggerYposition = (arr: Float64Array, dir: 'top' | 'bottom') => {
  return (_: HTMLElement, index: number, length: number) => {
    const loudnessIndex = index * Math.floor(arr.length / length)
    const dataPoint = arr[loudnessIndex] * 50
    return dir === 'bottom' ? `${50 + dataPoint}%` : `${50 - dataPoint}%`
  }
}

export const animateValues = (cssSelector: string, loudness: Float64Array) => {
  return anime({
    targets: cssSelector,
    y1: staggerYposition(loudness, 'top'),
    y2: staggerYposition(loudness, 'bottom'),
    duration: 1000,
    easing: 'easeInOutCirc'
  })
}

export const setSoundwave = (cssSelector: string, loudness: Float64Array) => {
  const targets = document.querySelectorAll(cssSelector)
  targets.forEach((target, index) => {
    const loudnessIndex = index * Math.floor(loudness.length / targets.length)
    const dataPoint = loudness[loudnessIndex] * 50
    target.setAttribute('y1', `${50 - dataPoint}%`)
    target.setAttribute('y2', `${50 + dataPoint}%`)
  })
}
